var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 27.3333,
    cy: 27.3333,
    r: 26.6667,
    fill: "#0094FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3333,
    cy: 27.3333,
    r: 20,
    fill: "#0094FF",
    stroke: "white",
    strokeWidth: 2.66667
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_5266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4845 22.0089C33.3067 21.4844 32.8089 21.1111 32.2222 21.1111H22.4445C21.8578 21.1111 21.3689 21.4844 21.1822 22.0089L19.4311 27.0489C19.3689 27.2356 19.3333 27.4311 19.3333 27.6356V34C19.3333 34.7378 19.9289 35.3333 20.6667 35.3333C21.4045 35.3333 22 34.7378 22 34V33.5556H32.6667V34C32.6667 34.7289 33.2622 35.3333 34 35.3333C34.7289 35.3333 35.3333 34.7378 35.3333 34V27.6356C35.3333 27.44 35.2978 27.2356 35.2356 27.0489L33.4845 22.0089ZM22.4445 30.8889C21.7067 30.8889 21.1111 30.2933 21.1111 29.5556C21.1111 28.8178 21.7067 28.2222 22.4445 28.2222C23.1822 28.2222 23.7778 28.8178 23.7778 29.5556C23.7778 30.2933 23.1822 30.8889 22.4445 30.8889ZM32.2222 30.8889C31.4845 30.8889 30.8889 30.2933 30.8889 29.5556C30.8889 28.8178 31.4845 28.2222 32.2222 28.2222C32.96 28.2222 33.5556 28.8178 33.5556 29.5556C33.5556 30.2933 32.96 30.8889 32.2222 30.8889ZM21.1111 26.4444L22.24 23.0489C22.3645 22.6933 22.7022 22.4444 23.0845 22.4444H31.5822C31.9645 22.4444 32.3022 22.6933 32.4267 23.0489L33.5556 26.4444H21.1111Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_5266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(16.6667 16.6667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginMarker);
export default __webpack_public_path__ + "static/media/origin-marker.3a522ab6b65516f6bff81ca916629e3e.svg";
export { ForwardRef as ReactComponent };